import { Route } from 'react-router-dom';
import AuraTemplates from './components/pageComponents/AuraTemplates';

export const getTemplatesExchangeRoutes = ({ isMinimized }) => {
  const pages = [
    {
      path: '/templatesexchange',
      Component: AuraTemplates,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return (
      <Route
        key={index}
        path={path}
        element={<Component isMinimized={isMinimized} />}
      />
    );
  });
};
